<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box">
  <h3>{{ title }}</h3>
  <hr>
  <div class="row">
    <div class="col-12">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
              <thead>
                  <tr>
                    <th scope="col">IdRevision</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Estación</th>
                      <th scope="col">Etapa</th>
                      <th scope="col">Fecha inicio plan</th>
                      <th scope="col">Fecha fin plan</th>
                      <th scope="col">Fecha inicio real</th>
                      <th scope="col">Fecha fin real</th>
                      <th scope="col">Calificación</th>
                      <th scope="col">Sincronizar</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let revision of revisiones">
                    <td>{{ revision.IdRevision }}</td>
                    <td>{{ revision.Descripcion }}</td>
                    <td>{{ revision.Estacion.Nombre }}</td>
                    <td>{{ revision.Etapa.Descripcion }}</td>
                    <td>{{ revision.FechaInicioPlan }}</td>
                    <td>{{ revision.FechaFinPlan }}</td>
                    <td>{{ revision.FechaInicioReal }}</td>
                    <td>{{ revision.FechaFinReal }}</td>
                    <td>{{ revision.Calificacion }}</td>
                    <td style="text-align: center;">
                      <button type="button" class="btn btn-primary primary btn-sm" (click)="syncClick(revision.IdRevision)">
                          <i class="fa fa-sync"></i>
                      </button>
                    </td>
                  </tr>
              </tbody>
          </table>
        </div>
    </div>
  </div>
</div>







